module.exports = __webpack_public_path__ + "873f8ade228328f76eeab06856aa4a87.svg";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-regular.svg
// module id = 1540
// module chunks = 0